// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608272004/js/" + chunkId + "." + {"44":"0e70e15f","225":"3cb1a929","481":"d0c90cfa","486":"9e57c888","770":"ade72c54"}[chunkId] + ".0.6469613628896412.chunk.js";
};